
import { Product } from "@/types/product";

export const transmissionProducts: Product[] = [
  {
    id: "propeller-shaft",
    name: "PROPELLER SHAFT",
    description: "Also known as drive shafts, these components transfer rotational power from the transmission to the wheels, ensuring efficient motion. Made from high-strength alloy steel or carbon fiber composites, our propeller shafts provide superior torque transmission, reducing vibration and improving vehicle stability.",
    images: ["/assets/propeller-shaft/1.webp"],
    certifications: ["ISO 9001:2015", "TS 16949", "CE Certified"],
    minOrderQuantity: "100 units",
    availableFor: ["ECCO"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Propeller Shaft exporter to Global Markets | ISO 9001:2015, TS 16949 Certified | 2024 Verified Supplier"
  },
  {
    id: "flywheel-assembly",
    name: "FLYWHEEL ASSEMBLY",
    description: "A crucial part of the engine, the flywheel stores rotational energy to ensure smooth engine operation and enhance power transmission. Manufactured from high-quality cast iron or steel, our flywheel assemblies improve engine efficiency, reduce vibration, and enhance overall vehicle performance.",
    images: ["/assets/flywheel-assembly/1.webp"],
    certifications: ["ISO 9001:2015", "TS 16949"],
    minOrderQuantity: "100 units",
    availableFor: ["ASHOK LEYLAND"],
    shippingPorts: ["Dubai", "Mombasa", "Rotterdam"],
    metaDescription: "Trusted Flywheel Assembly exporter to Global Markets | ISO 9001:2015 Certified | 2024 Verified Supplier"
  }
];
